import React from 'react'
import "./App.css"

function Footer() {
  return (
    <footer><h3> &copy;<a href='https://www.facebook.com/profile.php?id=100030223352000&mibextid=ZbWKwL' target='_blank'>omar othman</a> - fawry plus </h3></footer>
  )
}

export default Footer